import * as Api from '@ViewModels';
import * as React from 'react';
import { Button } from '../../../components-v2/Button';
import { RotateCCWClockIcon } from '../../svgs/icons/RotateCCWClockIcon';
import { SimpleTooltip } from '../../Tooltip';
import { styleSheet } from './styles';

interface IProps {
	isEdited: boolean;
	onResetToBase: () => void;
	platform: Api.SocialMediaType;
	readOnly?: boolean;
}

/** Only an edited version has anything to go back to, so the control appears with the tab's dot. */
export const PlatformVersionReset: React.FC<IProps> = ({ isEdited, onResetToBase, platform, readOnly }) => {
	if (!isEdited || readOnly) {
		return null;
	}

	return (
		<SimpleTooltip title={`Replace the ${platform} version with the base post`}>
			<Button onClick={onResetToBase} size='sm' styles={[styleSheet.resetButton]} type='button' variant='ghost'>
				<RotateCCWClockIcon />
				<span>Reset</span>
			</Button>
		</SimpleTooltip>
	);
};
